import type { Product } from '@maestro/data-layer'

import { theme } from '@maestro/local/theme'

export function getProductQuantityLimit(
  product: Product,
  variantId: string
): number {
  // 1. Determine Product Stock (online or store):
  // If both are missing (undefined/null), fall back to theme default.
  const productStockLevel = Math.max(
    product.stock?.availableQuantity ?? 0,
    product.stock?.availableStoreCount ?? 0
  )

  let quantityLimit = productStockLevel ?? theme().cms.quantityCounterMaxValue

  const selectedVariant = product.variants?.find(
    (variant) => variant.id === variantId
  )

  if (selectedVariant) {
    // 2. Determine Variant Stock (Override product stock if variant exists)
    const variantStockLevel = Math.max(
      selectedVariant.stock?.availableQuantity ?? 0,
      selectedVariant.stock?.availableStoreCount ?? 0
    )

    quantityLimit =
      variantStockLevel > 0
        ? variantStockLevel
        : theme().cms.quantityCounterMaxValue
  }

  return quantityLimit
}
